module.exports = __webpack_public_path__ + "static/media/estimate-icon-card.faa718ae.svg";